import { useMemo, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

const useDnd = ({ canDropOnRow, row, enableRowDragging, checked, selectedRowIds, enableCheckboxSelection, width, onRowsDrag, }) => {
    const canDropItem = useMemo(() => {
        return canDropOnRow ? canDropOnRow(row) : true;
    }, [canDropOnRow, row]);
    const previewRef = useRef(null);
    const [, drag, preview] = useDrag(() => ({
        type: 'row',
        canDrag: enableRowDragging || false,
        item: {
            id: row.id,
            checked,
            selectedRowIds,
            enableCheckboxSelection,
            width,
        },
    }), [selectedRowIds, row.id]);
    const [{ isOver, canDrop, item }, drop] = useDrop(() => ({
        accept: 'row',
        canDrop: (item) => !row.isSelected && (item === null || item === void 0 ? void 0 : item.id) !== row.id && canDropItem,
        drop: item => {
            const count = Object.keys(item.selectedRowIds).length;
            const sourceRowIds = count ? [...Object.keys(item.selectedRowIds)] : [item.id];
            onRowsDrag && onRowsDrag(sourceRowIds, row.id);
            return undefined;
        },
        collect: monitor => {
            return {
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
                item: monitor.getItem(),
            };
        },
    }), [row.original, selectedRowIds]);
    const isDragged = useMemo(() => {
        var _a, _b;
        return (item &&
            !(item === null || item === void 0 ? void 0 : item.columnId) &&
            (((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = row.id) === null || _b === void 0 ? void 0 : _b.toString()) ||
                (item && selectedRowIds && Object.keys(selectedRowIds).some(s => { var _a; return s.toString() === ((_a = row.id) === null || _a === void 0 ? void 0 : _a.toString()); }))));
    }, [item, row.id, selectedRowIds]);
    preview(previewRef);
    return {
        isDragged,
        previewRef,
        drag,
        preview,
        isOver,
        canDrop,
        item,
        drop,
    };
};

export { useDnd };
//# sourceMappingURL=useDnd.js.map
